module.exports = __webpack_public_path__ + "img/improved-traffic-flow.c826b1ef.svg";